const taskHasErrored = task => task.error

export default taskHasErrored